import { Layer } from '@connect-services/client/sdk/api/model/layer';
import { AssertService } from '@connect-services/client/services/assert.service';

export interface GeomLayer extends Omit<Layer, 'isVisible' | 'order'> {
    isVisible: boolean;
    order: number;
}

export const GeomLayer = {
    fromLayer(layer: Layer): GeomLayer {
        AssertService.isGeomLayer(layer);

        return layer;
    },
};
